// extracted by mini-css-extract-plugin
export default {"advert-panel":"index_advert-panel_S8zSD"};